<app-field-selector [questions]="questions" [templateProfile]="templateProfile" [field]="field" (select)="selected($event)"></app-field-selector>
